<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
            Service Estimate List 
            </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create" 
              >
                Add Service Estimate
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                            class = "btn"
                            :fields="field_export"
                            :worksheet="worksheetName"
                            :name="fileName"
                            :fetch= "()=>{return dataExportBefore('all')}"
                            
                          >
                            All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                            class = "btn"
                            :data="exportDisplayedPage"
                            :fields="field_export"
                            :worksheet="worksheetName"
                            :name="fileName"
                          >
                            Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                            class = "btn"
                            :fields="field_export"
                            :worksheet="worksheetName"
                            :name="fileName"
                            :fetch= "()=>{return dataExportBefore('filter')}"
                          >
                            All filtered record
                          </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search=''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                    class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
                <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
              </div>
            </v-card-title>
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{'items-per-page-options':[30, 50, 100]}"
            >

              <template v-slot:[`header.service_estimate_type`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionSEType"
                  :label="header.text"
                  v-model="valueSEType"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>
          
              <template v-slot:[`header.status`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionStatus"
                  :label="header.text"
                  v-model="valueStatus"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>
              <template v-slot:[`header.pool`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionPool"
                  :label="header.text"
                  v-model="valuePool"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>
              <template v-slot:[`item.detail`]="{ item }">
                <router-link :to="{name: 'Detail Service Estimate', params: { id: item.id }}" class="btn btn-primary">Detail
                </router-link>
              </template>

              <template v-slot:[`item.vehicle_types`]="{ item }">
                <span v-if="item.service_estimate_vehicle">{{ "("+item.service_estimate_vehicle.vehicle_types.vehicle_brands.vehicle_brand_name+") "+' '+ item.service_estimate_vehicle.vehicle_types.vehicle_model+' '+ item.service_estimate_vehicle.vehicle_types.vehicle_year_model }} </span>
              </template>

              <template v-slot:[`item.pool`]="{ item }">
                <span >{{ item.service_estimate_pool.pool_name}} </span>
              </template>

              <template v-slot:[`item.service_estimate_type`]="{ item }">
                <span v-if="item.service_estimate_type == 1">Internal</span>
                <span v-if="item.service_estimate_type == 2">External</span>
              </template>

              <template v-slot:[`item.vehicle_plate_no`]="{ item }">
                <span v-if="item.service_estimate_type != 2 && item.service_estimate_vehicle">{{ item.service_estimate_vehicle.vehicle_plate_no}}</span>
                <span v-if="item.service_estimate_type == 2 && item.service_estimate_vehicle">{{ item.service_estimate_vehicle.vehicle_external_plate_no}}</span>
              </template>

              <template v-slot:[`item.customer_name`]="{ item }">
                <span v-if="item.service_estimate_type == 1 && item.service_estimate_billed == 1 && item.service_estimate_client">{{ item.service_estimate_client.client_name}}</span>
                <span v-if="item.service_estimate_type == 1 && item.service_estimate_billed == 2 && item.service_estimate_client">{{ item.service_estimate_client.driver_name}}</span>
                <span v-if="item.service_estimate_type == 2 && item.service_estimate_vehicle">{{ item.service_estimate_vehicle.vehicle_external_name}}</span>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.service_estimate_status==0">Registered</span>
                <span v-else-if="item.service_estimate_status==1">Waiting Approval</span>
                <span v-else-if="item.service_estimate_status==2 && item.service_estimate_pkb">PKB Created</span>
                <span v-else-if="item.service_estimate_status==2 && !item.service_estimate_pkb">Aproved</span>
                <span v-else-if="item.service_estimate_status==3">Rejected</span>
              </template>
              <template v-slot:[`item.body_color`]="{ item }">
                <span v-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==0">Putih</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==1">Putih Kuning</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==2">Putih Metalik</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==3">Hitam</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==4">Hitam Metalik</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==5">Silver</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==6">Silver Metalik</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==7">Abu Abu</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==8">Abu Abu Metalik</span>
                <span v-else-if="item.service_estimate_type != 2 && item.service_estimate_vehicle && item.service_estimate_vehicle.vehicle_body_color==9">N/A</span>
                <span v-else-if="item.service_estimate_type == 2 && item.service_estimate_vehicle">{{ item.service_estimate_vehicle.vehicle_external_body_color}}</span>
              </template>
            
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailSE(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="role.update && item.service_estimate_status == 0" @click="editSE(item.id)">
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="role.delete && item.service_estimate_status == 0" @click="deleteConfirmation(item.id)">
                      <v-list-item-title >Delete</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="createPkb(item.id)" v-if="!item.service_estimate_pkb && item.service_estimate_status==2">
                      <v-list-item-title >Create PKB</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.service_estimate_pkb!=null" @click="showPkb(item.service_estimate_pkb.id)">
                      <v-list-item-title >View PKB</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
        <h3 >ADD SERVICE ESTIMATE</h3>
        </div>
        <md-button style="z-index: 1;" class="md-icon-button md-dense md-round"  @click="modalCloseAdd()">
          <md-icon >close</md-icon>
        </md-button>
      </template>
      <template v-slot:body >
        <add-se />
      </template>
    </modal>
    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
        <h3 >EDIT SERVICE ESTIMATE</h3>
        </div>
        <md-button style="z-index: 1;" class="md-icon-button md-dense md-round"  @click="modalCloseEdit()">
          <md-icon >close</md-icon>
        </md-button>
      </template>
      <template v-slot:body >
        <edit-se :data_id="$refs.modalEditPage.data"/>
      </template>
    </modal>
    <modal ref="modalCreatePkbPage">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
        <h3 >CREATE PKB</h3>
        </div>
        <md-button class="md-icon-button md-dense md-round"  @click="modalCloseCreatePkb()">
          <md-icon >close</md-icon>
        </md-button>
      </template>
      <template v-slot:body >
        <create-pkb :data_id="$refs.modalCreatePkbPage.data"/>
      </template>
    </modal>
    <modal ref="modalDetailPage">
      <template v-slot:body >
        <detail-se :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal>
    <modal ref="modalShowDetailPkbPage">
      <template v-slot:body >
        <show-detail-pkb :data_id="$refs.modalShowDetailPkbPage.data" />
      </template>
    </modal>
  </div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { Modal } from "@/components";
import DetailSE from "@/pages/Dashboard/Workshop/ServiceEstimate/DetailSEPage.vue";
import AddSE from "@/pages/Dashboard/Workshop/ServiceEstimate/AddSEPage.vue";
import CreatePkb from "@/pages/Dashboard/Workshop/PKB/AddPKBPage.vue";
import EditSE from "@/pages/Dashboard/Workshop/ServiceEstimate/EditSEPage.vue";
import DetailPkb from "@/pages/Dashboard/Workshop/PKB/DetailPKBPage.vue";
import JsonExcel from "vue-json-excel";
import Swal from 'sweetalert2';
import { ResizablePage } from "@/components";

export default {
  components: {
  downloadExcel: JsonExcel,ResizablePage, Modal, "detail-se" : DetailSE ,
  "add-se" : AddSE , "edit-se" : EditSE , "create-pkb" : CreatePkb, "show-detail-pkb" : DetailPkb
  },
  vuetify,
  data () {
    return {
      valueSeType: 0,
      optionSeType: null,
      user: null,
      mounted:true,
      searchValue:null,
      searchCategory:null,
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: true, 
      option_filter: [ 
        { text: 'Service Estimate No', value: 'service_estimate_no' },
        { text: 'Plate No', value: 'vehicle_plate_no' },
        { text: 'Customer/Client name', value: 'customer_name' },
        { text: 'Vehicle No', value: 'vehicle_door_no' }],
      optionStatus: [
        { text: "All", value: "" },
        { text: "Registered", value: "registered" },
        { text: "Waiting Approval", value: "waiting_approval" },
        { text: "Aproved", value: "aproved" },
        { text: "PKB Created", value: "pkb_created" },
        { text: "Rejected", value: "rejected" },
      ],
      valueSEType: "",
      optionSEType: [
        { text: "All", value: "" },
        { text: "External", value: "2" },
        { text: "Internal", value: "1" }
      ],
      valueStatus: "",
      optionPool: [
        { text: "All", value: "" },
      ],
      valuePool: "",
      options: {},
      role: "",
      search: '',
      headers: [
        // {
        //   text: 'Detail',
        //   align: 'start center',
        //   value: 'detail',
        //   sortable: false
        // },
        {
        text: 'Actions',
        align: 'start center',
        value: 'actions',
        sortable: false
        },
        { text: 'Status', value: 'status' , sortable: false, width:'120'},
        { text: 'Service Type', value: 'service_estimate_type', width:'120', sortable: false},
        { text: 'Service Estimate No', value: 'service_estimate_no' },
        { text: 'Plate No.', value: 'vehicle_plate_no'}, 
        { text: 'Customer/Client name', value: 'customer_name'}, 
        { text: 'Vehicle No', value: 'service_estimate_vehicle.vehicle_door_no', width:'100'},
        { text: 'Vehicle Type', value: 'vehicle_types', width:'230'},
        { text: 'Color', value: 'body_color', width:'130'},
        { text: 'Datetime', value: 'service_estimate_create_at_datetime' , width:'150'},
        { text: 'Created At', value: 'created_at', align: 'center', width:'200'},
      ],
      table: [],
      worksheetName: "Service Estimate",
      fileName:"Service Estimate.xls",
      exportDisplayedPage:[],
      exportAllFitered:[],
      exportAll:[],
      field_export: {
        'no': 'no',
        'Service Estimate No': 'service_estimate_no',
        'Create Datetime': 'service_estimate_create_at_datetime',
        'Type': 'service_estimate_type',
        'Pool': 'service_estimate_pool',
        'PPN/NO PPN': 'service_estimate_ppn',
        'PKB No.': 'service_estimate_pkb_no',
        'Guarantee/Not Guarantee': 'service_estimate_guarantee',
        'Client Phone': 'client_phone',
        'Client Name': 'client_name',
        'Client Email': 'client_email',
        'Client Address': 'client_address',
        'Vehicle Plate No': 'service_estimate_vehicle_plate_no',
        'Vehicle Vehicle No': 'service_estimate_vehicle_door_no',
        'Vehicle Model Car': 'service_estimate_vehicle_model_car',
        'Vehicle Body Color': 'service_estimate_vehicle_body_color',
        'Vehicle KM': 'service_estimate_vehicle_km',
        'Vehicle Production Year': 'service_estimate_vehicle_production_year',
        'Vehicle Chasis No': 'service_estimate_vehicle_chasis_no',
        'Vehicle Engine No': 'service_estimate_vehicle_engine_no',
        'No Service': 'no_service',
        'Service Name': 'service_estimate_service_name',
        'Service Code': 'service_estimate_service_code',
        'Lts': 'service_estimate_service_lts',
        'Service Price': 'service_estimate_service_price',
        'Service Total': 'service_estimate_service_total',
        'Service Remark': 'service_estimate_service_remark',
        'No Part' : 'no_part',
        'Part Name': 'service_estimate_part_name',
        'Part Code': 'service_estimate_part_code',
        'Part Price': 'service_estimate_part_price',
        'Part Qty': 'service_estimate_part_qty',
        'Part Total': 'service_estimate_part_total',
        'Part Remark': 'service_estimate_part_remark',
        'Created At' : 'created_at',
        'Updated At' : 'updated_at'
      },
    }
  },
    
  watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
  
  async mounted() {
    //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
    this.$root.$refs.ListServiceEstimatePage = this;
    //check saat page terbuka apakah ada params 
    if(this.$route.params.id){
      //open detail
      this.detailSE(this.$route.params.id)
    }
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];

      this.user = await this.$store.getters["profile/me"];
      if(!this.user.pool){
        this.headers.push({ text: "Pool", value: "pool", sortable: false, width:'120' });
        await this.$store.dispatch("workshop_pool/list");
        await this.$store.getters["workshop_pool/list"].forEach((value, index) => {
          this.optionPool.push({ text: value.pool_name, value:  value.id});
         });
      }
      this.getList();
      this.mounted = false
    },

    methods: {
       // ambil data yang dibutuhkan
      async getList() {
        this.loadTable= true
        const { page, itemsPerPage,sortBy,sortDesc } = this.options;
        console.log(this.options)
        let pageNumber = page;
        
        
        var query = {"page":{number:pageNumber,size:itemsPerPage}}

        if(sortBy.length!=0){
          var  sort=sortBy[0]
          if(sortDesc[0]){
            sort="-"+sortBy[0]
          }
          query.sort = sort
        }

        if(this.searchValue && this.searchCategory){
          
          if(query.filter){
            Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
          }
          else{
            query.filter = {[this.searchCategory]:this.searchValue}
          }
        }

        if(this.valueStatus!=''){
          if(query.filter){
            Object.assign(query.filter, {status:this.valueStatus});
          }
          else{
            query.filter = {status:this.valueStatus}
          }
        }

        if(this.valueSEType!=''){
          if(query.filter){
            Object.assign(query.filter, {service_estimate_type:this.valueSEType});
          }
          else{
            query.filter = {service_estimate_type:this.valueSEType}
          }
        }

        if(this.valuePool!=''){
          if(query.filter){
            Object.assign(query.filter, {service_estimate_pool:this.valuePool});
          }
          else{
            query.filter = {service_estimate_pool:this.valuePool}
          }
        }
      
        await this.$store.dispatch("workshop_service_estimate/list",query);
        // if (
        //   (await this.$store.getters["role/list"]) &&
        //   (await this.$store.getters["role/list"].length) != 0
        // ) {
          this.table = await this.$store.getters["workshop_service_estimate/list"];
          var pageMeta  = await this.$store.getters["workshop_service_estimate/page"];
        // }
        // else{
        //   this.table = []
        // }
        console.log(pageMeta)
        this.totalDataTable = pageMeta.total
        this.numberOfPages = pageMeta['to']
        this.loadTable= false
      },

      detailSE(id){
        this.$refs.modalDetailPage.openModal({id:id , mode: "se"})
      },
      modalCloseDetail(){
        this.$refs.modalDetailPage.closeModal()
        this.getList();
      },

      editSE(id){
        this.$refs.modalEditPage.openModal({id:id})
      },
      modalCloseEdit(){
        this.$refs.modalEditPage.closeModal()
        this.getList();
      },

      createPkb(id){
        this.$refs.modalCreatePkbPage.openModal({id:id, mode:"se"})
      },
      modalCloseCreatePkb(){
        this.$refs.modalCreatePkbPage.closeModal()
        this.getList();
      },

      showPkb(id){
        this.$refs.modalShowDetailPkbPage.openModal({id:id, mode: "se"})
      },
      modalCloseShowDetailPkb(){
        this.$refs.modalShowDetailPkbPage.closeModal()
        this.getList();
      },
      
      searchButton(){
        this.options.page = 1;
        this.searchValue = this.search
        this.getList()
      },
      clearSearchButton(){
        this.options.page = 1;
        this.searchValue = null
        this.search = null
        this.searchCategory = null
        this.getList()
      },

      getFiltered(data){
      this.exportDisplayedPage = this.dataExport(data)
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
      },

    // fungsi tombol direct ke add page
      // addData() {
      //   // panggil add page
      //  this.$router.push({name: 'Add Service Estimate'});
      // },

      addData(){
        this.$refs.modalAddPage.openModal()
      },
      modalCloseAdd(){
        this.$refs.modalAddPage.closeModal();
        this.getList();

      },

      deleteConfirmation(id) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You wont be able to revert this!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.deleteServiceEstimate(id)
          }
        });
      },
      
      // fungsi delete data
      async deleteServiceEstimate(id) {
        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_service_estimate/destroy", id)
          //panggil alert succes
          await this.$store.dispatch("alerts/success", "User data delete successfully.")
          //kembali ke page list
          // this.$router.replace({ name: 'List Service Estimate'})
          this.getList();
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }
      },

      async dataExportBefore(type){
        if(this.table.length!=0){
          
          if(type=="all"){
            await this.$store.dispatch("workshop_service_estimate/list");
            return this.dataExport(await this.$store.getters["workshop_service_estimate/list"]);
          }
          else if(type=="filter"){
            var query = {}
            if(this.searchValue && this.searchCategory){
          
              if(query.filter){
                Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
              }
              else{
                query.filter = {[this.searchCategory]:this.searchValue}
              }
            }

            if(this.valueSEType!=''){
              if(query.filter){
                Object.assign(query.filter, {service_estimate_type:this.valueSEType});
              }
              else{
                query.filter = {service_estimate_type:this.valueSEType}
              }
            }
          // if(this.valueStatus!=''){
          //   if(query.filter){
          //     Object.assign(query.filter, {procurement_order_status:this.valueStatus});
          //   }
          //   else{
          //     query.filter = {procurement_order_status:this.valueStatus}
          //   }
          // }
          
          await this.$store.dispatch("workshop_service_estimate/list",query);
          return this.dataExport(await this.$store.getters["workshop_service_estimate/list"]);
        }
      }
    },
     //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data){
      var dataReturn=[]
      data.forEach((value_1, index_1) => {
        // console.log(value_1)
        var client_phone= null
        var client_name= null
        var client_email= null
        var client_address= null
        var pkb= null
        var vehicle_model = null
        var vehicle_plate_no = null
        var vehicle_production_year = null
        var vehicle_chassis_no = null
        var vehicle_engine_no = null
        var vehicle_door_no = null
        var vehicle_body_color = null
        if(value_1.service_estimate_vehicle){
          if(value_1.service_estimate_type == 1){
            vehicle_plate_no = value_1.service_estimate_vehicle?value_1.service_estimate_vehicle.vehicle_plate_no:null
            vehicle_production_year = value_1.service_estimate_vehicle.vehicle_production_year
            vehicle_chassis_no = value_1.service_estimate_vehicle.vehicle_chassis_no
            vehicle_engine_no = value_1.service_estimate_vehicle.vehicle_engine_no
            vehicle_door_no = value_1.service_estimate_vehicle?value_1.service_estimate_vehicle.vehicle_door_no:null
          
            if(value_1.service_estimate_vehicle.vehicle_body_color == 0){
              vehicle_body_color = "Putih"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 1){
              vehicle_body_color = "Putih Kuning"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 2){
              vehicle_body_color = "Putih Metalik"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 3){
              vehicle_body_color = "Hitam"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 4){
              vehicle_body_color = "Hitam Metalik"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 5){
              vehicle_body_color = "Silver"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 6){
              vehicle_body_color = "Silver Metalik"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 7){
              vehicle_body_color = "Abu Abu"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 8){
              vehicle_body_color = "Abu Abu Metalik"
            }
            else if(value_1.service_estimate_vehicle.vehicle_body_color == 9){
              vehicle_body_color = "N/A"
            }

            if( value_1.service_estimate_client && value_1.service_estimate_type == 1 && value_1.service_estimate_billed == 2 ){
              console.log(value_1.service_estimate_client);
              client_phone = value_1.service_estimate_client.driver_phone_no
              client_name = value_1.service_estimate_client.driver_name
              client_email = value_1.service_estimate_client.driver_email
              client_address =value_1.service_estimate_client.driver_address
            }
             else if(value_1.service_estimate_client && value_1.service_estimate_type == 1 && value_1.service_estimate_billed ==1 ){
              client_phone = value_1.service_estimate_client.client_phone
              client_name = value_1.service_estimate_client.client_name
              client_email = value_1.service_estimate_client.client_email
              client_address =value_1.service_estimate_client.client_address
            }
              
          }
          
          else if(value_1.service_estimate_type == 2){
            vehicle_body_color = value_1.service_estimate_vehicle.vehicle_external_body_color
            vehicle_plate_no = value_1.service_estimate_vehicle.vehicle_external_plate_no
            vehicle_production_year = value_1.service_estimate_vehicle.vehicle_external_production_year
            vehicle_chassis_no = value_1.service_estimate_vehicle.vehicle_external_chassis_no
            vehicle_engine_no = value_1.service_estimate_vehicle.vehicle_external_engine_no
            client_phone = value_1.service_estimate_vehicle.vehicle_external_phone
            client_name = value_1.service_estimate_vehicle.vehicle_external_name
            client_email = value_1.service_estimate_vehicle.vehicle_external_email
            client_address =value_1.service_estimate_vehicle.vehicle_external_address
          }
          

          
        }

        
        if(value_1.service_estimate_vehicle){
          vehicle_model =  value_1.service_estimate_vehicle.vehicle_types.vehicle_brands.vehicle_brand_name+', '+ value_1.service_estimate_vehicle.vehicle_types.vehicle_model+' '+ value_1.service_estimate_vehicle.vehicle_types.vehicle_year_model
        }
        if(value_1.service_estimate_pkb){
          pkb = value_1.service_estimate_pkb.pkb_no
        }
      
        if(value_1.service_estimate_service.length != 0 || value_1.service_estimate_part.length != 0){
          if(value_1.service_estimate_service.length >= value_1.service_estimate_part.length){
            value_1.service_estimate_service.forEach((value_2, index_2) => {
                      
              //this.dataExsport.push
              if(value_1.service_estimate_part[index_2]){
                // console.log(index_1+", "+value_1.service_estimate_no+" service "+value_2.service_category_name+' - '+value_1.service_estimate_part[index_2].id)
                var no = null
                if(index_2 == 0){
                  no = index_1+1
                }
                var data= {
                  'no': no,
                  'service_estimate_no': value_1.service_estimate_no,
                  'service_estimate_create_at_datetime': value_1.service_estimate_create_at_datetime,
                  'service_estimate_type': value_1.service_estimate_type==1 ? "Internal" : "External",
                  'service_estimate_pool': value_1.service_estimate_pool.pool_name,
                  'service_estimate_ppn': value_1.service_estimate_ppn==0 ? "Yes" : "no",
                  'service_estimate_pkb_no': pkb,
                  'service_estimate_guarantee': value_1.service_estimate_guarantee==1 ? "Yes" : "no",
                  'client_phone': client_phone,
                  'client_name': client_name,
                  'client_email': client_email,
                  'client_address': client_address,
                  'service_estimate_vehicle_plate_no': vehicle_plate_no,
                  'service_estimate_vehicle_door_no': vehicle_door_no,
                  'service_estimate_vehicle_model_car': vehicle_model,
                  'service_estimate_vehicle_body_color': vehicle_body_color,
                  'service_estimate_vehicle_km': value_1.service_estimate_vehicle_km,
                  'service_estimate_vehicle_production_year': vehicle_production_year,
                  'service_estimate_vehicle_chasis_no': vehicle_chassis_no,
                  'service_estimate_vehicle_engine_no': vehicle_engine_no,
                  'no_service': index_2+1,
                  'service_estimate_service_name': value_2.service_master_name,
                  'service_estimate_service_code': value_2.service_master_code,
                  'service_estimate_service_lts': value_2.service_master_lts,
                  'service_estimate_service_price': value_2.service_category_standard_cost,
                  'service_estimate_service_total': Math.round(value_2.service_master_lts * value_2.service_category_standard_cost),
                  'service_estimate_service_remark': value_2.service_estimate_service_remark,
                  'no_part': index_2+1,
                  'service_estimate_part_name': value_1.service_estimate_part[index_2].spare_part_master_name,
                  'service_estimate_part_code': value_1.service_estimate_part[index_2].spare_part_master_code,
                  'service_estimate_part_price': value_1.service_estimate_part[index_2].spare_part_master_unit_price,
                  'service_estimate_part_qty': value_1.service_estimate_part[index_2].service_estimate_spare_part_qty,
                  'service_estimate_part_total': value_1.service_estimate_part[index_2].service_estimate_spare_part_qty * value_1.service_estimate_part[index_2].spare_part_master_unit_price,
                  'service_estimate_part_remark': value_1.service_estimate_part[index_2].service_estimate_spare_part_remark,
                  'created_at' : value_1.created_at,
                  'updated_at' : value_1.updated_at
                }
                  
                dataReturn.push(data)
              }
              else{
                // console.log(index_1+", "+value_1.service_estimate_no+" service "+value_2.service_category_name+' - kosong')
                var no = null
                if(index_2 == 0){
                  no = index_1+1
                }
                var data= {
                  'no': no,
                  'service_estimate_no': value_1.service_estimate_no,
                  'service_estimate_create_at_datetime': value_1.service_estimate_create_at_datetime,
                  'service_estimate_type': value_1.service_estimate_type==1 ? "Internal" : "External",
                  'service_estimate_pool': value_1.service_estimate_pool.pool_name,
                  'service_estimate_ppn':value_1.service_estimate_ppn==1 ? "Yes" : "no",
                  'service_estimate_pkb_no': pkb,
                  'service_estimate_guarantee': value_1.service_estimate_guarantee==1 ? "Yes" : "no",
                  'client_phone': client_phone,
                  'client_name': client_name,
                  'client_email': client_email,
                  'client_address': client_address,
                  'service_estimate_vehicle_plate_no': vehicle_plate_no,
                  'service_estimate_vehicle_door_no': vehicle_door_no,
                  'service_estimate_vehicle_model_car': vehicle_model,
                  'service_estimate_vehicle_body_color': vehicle_body_color,
                  'service_estimate_vehicle_km': value_1.service_estimate_vehicle_km,
                  'service_estimate_vehicle_production_year': vehicle_production_year,
                  'service_estimate_vehicle_chasis_no': vehicle_chassis_no,
                  'service_estimate_vehicle_engine_no': vehicle_engine_no,
                  'no_service': index_2+1,
                  'service_estimate_service_name': value_2.service_master_name,
                  'service_estimate_service_code': value_2.service_master_code,
                  'service_estimate_service_lts': value_2.service_master_lts,
                  'service_estimate_service_price': value_2.service_category_standard_cost,
                  'service_estimate_service_total': Math.round(value_2.service_master_lts * value_2.service_category_standard_cost),
                  'service_estimate_service_remark': value_2.service_estimate_service_remark,
                  'no_part': null,
                  'service_estimate_part_name': null,
                  'service_estimate_part_code': null,
                  'service_estimate_part_price': null,
                  'service_estimate_part_qty': null,
                  'service_estimate_part_total': null,
                  'service_estimate_part_remark': null,
                  'created_at' : value_1.created_at,
                  'updated_at' : value_1.updated_at
                }
              dataReturn.push(data)
              }
                
            });
          }
          else{
            value_1.service_estimate_part.forEach((value_2, index_2) => {
              if(value_1.service_estimate_service[index_2]){
                // console.log(index_1+", "+value_1.service_estimate_no+" part "+value_2.spare_part_master_name+' - '+value_1.service_estimate_service[index_2].id)
                var no = null
                if(index_2 == 0){
                  no = index_1+1
                }
                var data= {
                  'no': no,
                  'service_estimate_no': value_1.service_estimate_no,
                  'service_estimate_create_at_datetime': value_1.service_estimate_create_at_datetime,
                  'service_estimate_type': value_1.service_estimate_type==1 ? "Internal" : "External",
                  'service_estimate_pool': value_1.service_estimate_pool.pool_name,
                  'service_estimate_ppn': value_1.service_estimate_ppn==1 ? "Yes" : "no",
                  'service_estimate_pkb_no': pkb,
                  'service_estimate_guarantee': value_1.service_estimate_guarantee==1 ? "Yes" : "no",
                  'client_phone': client_phone,
                  'client_name': client_name,
                  'client_email': client_email,
                  'client_address': client_address,
                'service_estimate_vehicle_plate_no': vehicle_plate_no,
                  'service_estimate_vehicle_door_no': vehicle_door_no,
                  'service_estimate_vehicle_model_car': vehicle_model,
                  'service_estimate_vehicle_body_color': vehicle_body_color,
                  'service_estimate_vehicle_km': value_1.service_estimate_vehicle_km,
                  'service_estimate_vehicle_production_year': vehicle_production_year,
                  'service_estimate_vehicle_chasis_no': vehicle_chassis_no,
                  'service_estimate_vehicle_engine_no': vehicle_engine_no,
                  'no_service': index_2+1,
                  'service_estimate_service_name': value_1.service_estimate_service[index_2].service_master_name,
                  'service_estimate_service_code': value_1.service_estimate_service[index_2].service_master_code,
                  'service_estimate_service_lts': value_1.service_estimate_service[index_2].service_master_lts,
                  'service_estimate_service_price': value_1.service_estimate_service[index_2].service_category_standard_cost,
                  'service_estimate_service_total': Math.round(value_1.service_estimate_service[index_2].service_master_lts * value_1.service_estimate_service[index_2].service_category_standard_cost),
                  'service_estimate_service_remark': value_1.service_estimate_service[index_2].service_estimate_service_remark,
                  'no_part': index_2+1,
                  'service_estimate_part_name': value_2.spare_part_master_name,
                  'service_estimate_part_code': value_2.spare_part_master_code,
                  'service_estimate_part_price': value_2.spare_part_master_unit_price,
                  'service_estimate_part_qty': value_2.service_estimate_spare_part_qty,
                  'service_estimate_part_total': value_2.service_estimate_spare_part_qty * value_2.spare_part_master_unit_price,
                  'service_estimate_part_remark': value_2.service_estimate_spare_part_remark,
                  'created_at' : value_1.created_at,
                  'updated_at' : value_1.updated_at
                }
              dataReturn.push(data)
              } 
              else{
                // console.log(index_1+", "+value_1.service_estimate_no+" part "+value_2.spare_part_master_name+' - kosong')
                var no = null
                if(index_2 == 0){
                  no = index_1+1
                }
                var data= {
                  'no': no,
                  'service_estimate_no': value_1.service_estimate_no,
                  'service_estimate_create_at_datetime': value_1.service_estimate_create_at_datetime,
                  'service_estimate_type': value_1.service_estimate_type==1 ? "Internal" : "External",
                  'service_estimate_pool': value_1.service_estimate_pool.pool_name,
                  'service_estimate_ppn':value_1.service_estimate_ppn==1 ? "Yes" : "no",
                  'service_estimate_pkb_no': pkb,
                  'service_estimate_guarantee': value_1.service_estimate_guarantee==1 ? "Yes" : "no",
                  'client_phone': client_phone,
                  'client_name': client_name,
                  'client_email': client_email,
                  'client_address': client_address,
                  'service_estimate_vehicle_plate_no': vehicle_plate_no,
                  'service_estimate_vehicle_door_no': vehicle_door_no,
                  'service_estimate_vehicle_model_car': vehicle_model,
                  'service_estimate_vehicle_body_color': vehicle_body_color,
                  'service_estimate_vehicle_km': value_1.service_estimate_vehicle_km,
                  'service_estimate_vehicle_production_year': vehicle_production_year,
                  'service_estimate_vehicle_chasis_no': vehicle_chassis_no,
                  'service_estimate_vehicle_engine_no': vehicle_engine_no,
                  'no_service': null,
                  'service_estimate_service_name': null,
                  'service_estimate_service_code': null,
                  'service_estimate_service_lts': null,
                  'service_estimate_service_price': null,
                  'service_estimate_service_total': null,
                  'service_estimate_service_remark': null,
                  'no_part': index_2+1,
                  'service_estimate_part_name': value_2.spare_part_master_name,
                  'service_estimate_part_code': value_2.spare_part_master_code,
                  'service_estimate_part_price': value_2.spare_part_master_unit_price,
                  'service_estimate_part_qty': value_2.service_estimate_spare_part_qty,
                  'service_estimate_part_total': value_2.service_estimate_spare_part_qty * value_2.spare_part_master_unit_price,
                  'service_estimate_part_remark': value_2.service_estimate_spare_part_remark,
                  'created_at' : value_1.created_at,
                  'updated_at' : value_1.updated_at
                }
                dataReturn.push(data)
              }
            });
          }
        }
        else{
          var data= {
            'no':index_1+1,
            'service_estimate_no': value_1.service_estimate_no,
            'service_estimate_create_at_datetime': value_1.service_estimate_create_at_datetime,
            'service_estimate_type': value_1.service_estimate_type==1 ? "Internal" : "External",
            'service_estimate_pool': value_1.service_estimate_pool.pool_name,
            'service_estimate_ppn': value_1.service_estimate_ppn==1 ? "Yes" : "no",
            'service_estimate_pkb_no': pkb,
            'service_estimate_guarantee': value_1.service_estimate_guarantee==1 ? "Yes" : "no",
            'client_phone': client_phone,
            'client_name': client_name,
            'client_email': client_email,
            'client_address': client_address,
            'service_estimate_vehicle_plate_no': vehicle_plate_no,
            'service_estimate_vehicle_door_no': vehicle_door_no,
            'service_estimate_vehicle_model_car': vehicle_model,
            'service_estimate_vehicle_body_color': vehicle_body_color,
            'service_estimate_vehicle_km': value_1.service_estimate_vehicle_km,
            'service_estimate_vehicle_production_year': vehicle_production_year,
            'service_estimate_vehicle_chasis_no': vehicle_chassis_no,
            'service_estimate_vehicle_engine_no': vehicle_engine_no,
            'no_service': null,
            'service_estimate_service_name': null,
            'service_estimate_service_code': null,
            'service_estimate_service_lts': null,
            'service_estimate_service_price': null,
            'service_estimate_service_total': null,
            'service_estimate_service_remark': null,
            'no_part': null,
            'service_estimate_part_name': null,
            'service_estimate_part_code': null,
            'service_estimate_part_price': null,
            'service_estimate_part_qty': null,
            'service_estimate_part_total': null,
            'service_estimate_part_remark': null,
            'created_at' : value_1.created_at,
            'updated_at' : value_1.updated_at
          }
        dataReturn.push(data)
        }
          

      });
      return dataReturn
    }
    
  },
}
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>